import { useMemo } from "react";
import type { TFunction } from "i18next";
import type { ConnectionPreviewTaskState } from "@onetasklist/shared";

export interface ConnectionPreviewDockText {
  title: string;
  expandAria: string;
  collapseAria: string;
  refresh: string;
  checking: string;
  waiting: string;
  noTasks: string;
  notRunYet: string;
  inactive: string;
  errorTitle: string;
  truncated: string;
  totalLabel: string;
  newLabel: string;
  existingLabel: string;
  archivedLabel: string;
  removedLabel: string;
  skippedLabel: string;
  skippedHint: string;
  stateLabel: (state: ConnectionPreviewTaskState) => string;
}

export const useConnectionPreviewDockText = (
  t: TFunction,
): ConnectionPreviewDockText =>
  useMemo(() => {
    const stateLabels: Record<ConnectionPreviewTaskState, string> = {
      New: t("board.connections.preview.stateNew"),
      Existing: t("board.connections.preview.stateExisting"),
      Archived: t("board.connections.preview.stateArchived"),
      Removed: t("board.connections.preview.stateRemoved"),
      SkippedByAgeLimit: t("board.connections.preview.stateSkipped"),
    };

    return {
      title: t("board.connections.preview.title"),
      expandAria: t("board.connections.preview.expandAria"),
      collapseAria: t("board.connections.preview.collapseAria"),
      refresh: t("board.connections.preview.refresh"),
      checking: t("board.connections.preview.checking"),
      waiting: t("board.connections.preview.waiting"),
      noTasks: t("board.connections.preview.noTasks"),
      notRunYet: t("board.connections.preview.notRunYet"),
      inactive: t("board.connections.preview.inactive"),
      errorTitle: t("board.connections.preview.errorTitle"),
      truncated: t("board.connections.preview.truncated"),
      totalLabel: t("board.connections.preview.totalLabel"),
      newLabel: t("board.connections.preview.newLabel"),
      existingLabel: t("board.connections.preview.existingLabel"),
      archivedLabel: t("board.connections.preview.archivedLabel"),
      removedLabel: t("board.connections.preview.removedLabel"),
      skippedLabel: t("board.connections.preview.skippedLabel"),
      skippedHint: t("board.connections.preview.skippedHint"),
      stateLabel: (state: ConnectionPreviewTaskState) =>
        stateLabels[state] ?? state,
    };
  }, [t]);
